export default __webpack_public_path__ + "static/Durian Corp_logo-c295594a3cc0c0303e4fb21d40259eec.png";